import { render } from "./MyCustomersView.vue?vue&type=template&id=3e6a6a8f&scoped=true"
import script from "./MyCustomersView.vue?vue&type=script&lang=js"
export * from "./MyCustomersView.vue?vue&type=script&lang=js"

import "./MyCustomersView.vue?vue&type=style&index=0&id=3e6a6a8f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6a6a8f"]])

export default __exports__